var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoptLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 29,
    viewBox: "0 0 100 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_212)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_212)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_212",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 0.139893H0V27.2982H100V0.139893Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_212)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.2178 5.55184C72.8129 5.95659 72.4496 6.40078 72.1333 6.87786C71.8169 6.40078 71.4538 5.95659 71.0489 5.55184C70.2516 4.75439 69.305 4.12184 68.2631 3.69031C67.2214 3.25878 66.1047 3.03676 64.977 3.03687H47.132V5.21982C45.559 3.81401 43.5232 3.03691 41.4135 3.03687H32.1554C29.8781 3.03687 27.6941 3.94153 26.0836 5.55184C25.6788 5.95659 25.3156 6.40078 24.9993 6.87786C24.6829 6.40078 24.3196 5.95659 23.9147 5.55184C22.3045 3.94153 20.1203 3.03687 17.8429 3.03687H0V27.152H17.845C18.9727 27.152 20.0894 26.9299 21.1313 26.4983C22.173 26.0664 23.1196 25.4337 23.9169 24.636C24.3221 24.2317 24.6854 23.7875 25.0013 23.31C25.3171 23.7875 25.6804 24.2317 26.0856 24.636C26.8829 25.4337 27.8293 26.0664 28.8712 26.4983C29.9131 26.9299 31.0299 27.152 32.1576 27.152H41.4156C43.5254 27.152 45.561 26.3749 47.1342 24.9691V27.152H61.7817V22.5261H64.9791C66.1068 22.5263 67.2234 22.3042 68.2653 21.8727C69.307 21.4412 70.2536 20.8087 71.0509 20.0112C71.1613 19.9008 71.2682 19.7882 71.3718 19.6731H76.5969V27.152H91.2444V19.6731H97.1336V3.03687H79.2887C78.1611 3.03678 77.0446 3.25883 76.0029 3.69036C74.9613 4.12189 74.0149 4.75443 73.2178 5.55184Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7083 1.60522H4.29492V22.8571H20.7083C22.6061 22.8569 24.4264 22.1031 25.7689 20.7616C27.1104 19.4191 27.8642 17.599 27.8645 15.7011V8.76128C27.8644 6.86368 27.1106 5.04378 25.7689 3.70187C25.1043 3.0372 24.3154 2.50995 23.4471 2.1502C22.5788 1.79045 21.6482 1.60527 20.7083 1.60522Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.86328 0.173584H20.7083C22.9856 0.173585 25.1698 1.07825 26.7802 2.68857C28.3905 4.29887 29.2951 6.48294 29.2951 8.76026V15.7011C29.2951 17.9784 28.3905 20.1624 26.7802 21.7727C25.1698 23.3831 22.9856 24.2878 20.7083 24.2878H2.86328V0.173584ZM5.7256 3.03583V21.4256H20.7083C21.4601 21.4256 22.2045 21.2775 22.8991 20.99C23.5937 20.7024 24.2248 20.2808 24.7565 19.7491C25.2881 19.2177 25.7097 18.5865 25.9973 17.8919C26.2851 17.1973 26.4329 16.4529 26.4329 15.7011V8.76128C26.4325 7.24308 25.8297 5.78707 24.7565 4.71315C24.2248 4.1816 23.5937 3.75997 22.8991 3.47234C22.2045 3.18472 21.4601 3.03675 20.7083 3.03684L5.7256 3.03583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5156 17.5869V8.14429H20.3779V17.5869H17.5156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8439 1.60522H51.4297V22.8571H63.2149V18.2314H67.8439C69.7416 18.2312 71.5615 17.4774 72.9034 16.1357C74.2453 14.7938 74.9991 12.9739 74.9991 11.0763V8.76128C74.9991 6.86368 74.2453 5.04378 72.9034 3.70187C72.2392 3.03714 71.4505 2.50986 70.5824 2.15009C69.7142 1.79034 68.7836 1.60518 67.8439 1.60522Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.998 0.173584H67.843C70.1205 0.173585 72.3045 1.07825 73.915 2.68857C75.5254 4.29887 76.4301 6.48294 76.4301 8.76026V11.0763C76.4301 13.3536 75.5254 15.5376 73.915 17.1479C72.3045 18.7583 70.1205 19.663 67.843 19.663H64.6446V24.2878H49.998V0.173584ZM52.8605 3.03583V21.4256H61.7824V16.8007H67.843C69.3614 16.8004 70.8173 16.1975 71.8914 15.1244C72.9644 14.0504 73.5675 12.5944 73.5676 11.0763V8.76128C73.5675 7.24308 72.9644 5.78707 71.8914 4.71315C70.8173 3.64002 69.3614 3.03711 67.843 3.03684L52.8605 3.03583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6562 13.9222V8.14087H67.5196V13.9222H64.6562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2805 1.60522H35.0224C34.0828 1.60505 33.1523 1.79004 32.2843 2.14963C31.4161 2.50921 30.6273 3.03632 29.9629 3.70085C29.2983 4.36517 28.7713 5.15393 28.4116 6.02204C28.0521 6.89017 27.867 7.82063 27.8672 8.76027V15.7011C27.8672 16.6409 28.0523 17.5715 28.4118 18.4398C28.7713 19.308 29.2985 20.097 29.9629 20.7616C31.305 22.1033 33.1247 22.8571 35.0224 22.8571H44.2805C46.1785 22.8569 47.9987 22.1031 49.3411 20.7616C50.6828 19.4191 51.4366 17.599 51.4368 15.7011V8.76128C51.4368 6.86368 50.6828 5.04378 49.3411 3.70188C48.6765 3.03722 47.8877 2.50995 47.0193 2.1502C46.1512 1.79045 45.2204 1.60527 44.2805 1.60522Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9487 2.68857C30.5589 1.07825 32.7431 0.173585 35.0204 0.173584H44.2805C46.558 0.173585 48.742 1.07825 50.3525 2.68857C51.9629 4.29887 52.8676 6.48294 52.8676 8.76026V15.7011C52.8676 17.9784 51.9629 20.1624 50.3525 21.7727C48.742 23.3831 46.558 24.2878 44.2805 24.2878H35.0224C32.7451 24.2878 30.5611 23.3831 28.9507 21.7727C27.3402 20.1624 26.4355 17.9784 26.4355 15.7011V8.76128C26.4352 7.63362 26.657 6.51695 27.0881 5.47499C27.5194 4.43303 28.1516 3.48619 28.9487 2.68857ZM35.0204 3.03583C33.5023 3.03608 32.0462 3.639 30.9722 4.71213C29.899 5.78607 29.2962 7.24205 29.2958 8.76026V15.7011C29.2958 16.4529 29.4438 17.1973 29.7314 17.8919C30.019 18.5865 30.4408 19.2177 30.9722 19.7491C32.0462 20.8223 33.5023 21.4252 35.0204 21.4256H44.2805C45.7989 21.4256 47.255 20.8225 48.3289 19.7491C48.8604 19.2177 49.2819 18.5865 49.5697 17.8919C49.8573 17.1973 50.0053 16.4529 50.0051 15.7011V8.76128C50.005 7.24308 49.4019 5.78707 48.3289 4.71315C47.7972 4.1816 47.1661 3.75997 46.4715 3.47234C45.7769 3.18472 45.0323 3.03675 44.2805 3.03684L35.0204 3.03583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.214 8.14429V17.5869H35.3516V8.14429H38.214Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5688 1.60522H82.1524C81.2126 1.60505 80.2821 1.79004 79.4141 2.14963C78.5459 2.50921 77.7571 3.03632 77.0927 3.70085C76.4281 4.36511 75.9008 5.15384 75.5411 6.02197C75.1812 6.89008 74.9961 7.82056 74.9961 8.76027V15.3782H80.8851V22.8571H92.6704V15.3782H98.5596L98.5688 1.60522Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.083 2.68857C77.6935 1.07825 79.8776 0.173585 82.155 0.173584H99.9999V16.8088H94.1109V24.2878H79.4633V16.8088H73.5742V8.76128C73.5722 6.48446 74.4748 4.30011 76.083 2.68857ZM82.155 3.03583C81.4032 3.03574 80.6588 3.18371 79.9642 3.47134C79.2695 3.75896 78.6384 4.18058 78.1068 4.71213C77.0336 5.78607 76.4307 7.24205 76.4303 8.76026V13.9466H82.3194V21.4256H91.2424V13.9466H97.1316V3.03583H82.155Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 28,
    fill: "white",
    transform: "translate(0 0.139893)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 28,
    fill: "white",
    transform: "translate(0 0.139893)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoptLogo);
export default __webpack_public_path__ + "static/media/dopt-logo.13758d10a8550747e08472bc4fe135e9.svg";
export { ForwardRef as ReactComponent };